import GraphqlBuilder from "utils/request/graphql/builder";
import _ from "lodash";
import MutationPushNotification from "graphql/mutations/MutationPushNotification";
import { constantsActive } from 'utils/constants/constants'

export default class MutatePushNotification {
	
	static archive = ( guid, { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		new GraphqlBuilder()
			.addQuery( 'push_notification_archive', MutationPushNotification, {
				guid: guid,
				active: constantsActive.NO
			} )
			.setResultPath(['push_notification_archive', 'push_notification'] , {} )
			.setOnStart( callbackStart )
			.setOnError( callbackError )
			.setOnSuccess( result => {
				if( _.isFunction( callbackSuccess ) ) {
					callbackSuccess({
						pushNotification: result
					});
				}
			})
			.execute()
	}
}
